import { Component } from '@angular/core';

import {
  CardComponent,
  CardContentComponent,
  CardCtaComponent,
  CardHeaderComponent,
  CardImageComponent,
  CardSubtitleComponent,
  CardTagComponent,
  CardTitleComponent,
  DashboardCardComponent,
} from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        CardComponent,
        CardContentComponent,
        CardCtaComponent,
        CardHeaderComponent,
        CardImageComponent,
        CardSubtitleComponent,
        CardTagComponent,
        CardTitleComponent,
        DashboardCardComponent,
        TestIdDirective,
    ],
    template: `
    <cam-card camTestId="cam-card">
      <cam-card-header camTestId="cam-card-header">
        <cam-card-title camTestId="cam-card-title">Card title</cam-card-title>
        <cam-card-subtitle camTestId="cam-card-subtitle">Card subtitle</cam-card-subtitle>
        <cam-card-tag camTestId="cam-card-tag">tag</cam-card-tag>
      </cam-card-header>
      <cam-card-image camTestId="cam-card-image" />
      <cam-card-content camTestId="cam-card-content">Card content</cam-card-content>
      <cam-card-cta camTestId="cam-card-cta">CTA</cam-card-cta>
    </cam-card>
    <cam-dashboard-card camTestId="cam-dashboard-card" icon="edit">Dashboard card</cam-dashboard-card>
  `
})
export class UiCardsCase {}
